import React from 'react'
import { Link } from 'react-router-dom'
import qs from 'querystring'
import { Card, Table, Tag } from 'antd'
import SupplierCoverageSearch from '../SupplierCoverageSearch'
import { ErrorBox, HotelLink, REGIONS_PATH } from '../CoverageCommon'
import container from './container'

const regionTag = region => (
    <Link
        key={`${region.supplier_code}-${region.region_id}`}
        to={`${REGIONS_PATH}?${qs.stringify({ region_id: region.region_id })}`}>
        <Tag color="blue" style={{ marginBottom: 2 }}>
            {region.region_name ? `${region.region_name} ` : ''}
            {region.region_id}
            {region.supplier_code && region.supplier_code !== 'EPS' ? ` · ${region.supplier_code}` : ''}
        </Tag>
    </Link>
)

const SupplierCoverage = props => {
    const { supplierCoverage, loading, query, handlePage } = props
    const column = (query && query.column) || ''

    const columns = [
        { key: 'hotel_id', dataIndex: 'hotel_id', title: 'Hotel ID', width: 110, render: id => <HotelLink id={id} /> },
        { key: 'name', title: 'Name', render: hotel => (hotel.static && hotel.static.name) || '' },
        { key: 'city', title: 'City', render: hotel => (hotel.static && hotel.static.city) || '' },
        {
            key: 'supplier_hotel_id',
            dataIndex: 'supplier_hotel_id',
            title: column || 'Supplier hotel id',
            width: 170
        },
        { key: 'rank', dataIndex: 'rank', title: 'Rank', width: 80 },
        {
            key: 'regions',
            title: 'Region mappings',
            render: hotel =>
                hotel.regions && hotel.regions.length ? (
                    hotel.regions.map(regionTag)
                ) : (
                    <span style={{ color: '#999' }}>no region mapping</span>
                )
        }
    ]

    const renderResult = () => {
        if (!supplierCoverage) {
            return loading ? <Card size="small" loading /> : null
        }
        if (!supplierCoverage.success) {
            return <ErrorBox result={supplierCoverage} />
        }
        return (
            <Card title={`${supplierCoverage.total} hotels mapped in ${supplierCoverage.column}`}>
                <Table
                    bordered
                    size="small"
                    rowKey="hotel_id"
                    loading={loading}
                    dataSource={supplierCoverage.hotels}
                    columns={columns}
                    pagination={{
                        current: supplierCoverage.page,
                        pageSize: supplierCoverage.page_size,
                        total: supplierCoverage.total,
                        showSizeChanger: true,
                        pageSizeOptions: ['20', '50', '100'],
                        onChange: handlePage
                    }}
                />
            </Card>
        )
    }

    return (
        <div>
            <SupplierCoverageSearch />
            <br />
            {renderResult()}
        </div>
    )
}

export default container(SupplierCoverage)
